export function GrainOverlay() {
  return (
    <div aria-hidden className="fixed inset-0 pointer-events-none z-[1] mix-blend-overlay opacity-[0.035]">
      <svg width="100%" height="100%">
        <filter id="jsl-grain">
          <feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="2" stitchTiles="stitch" />
          <feColorMatrix type="saturate" values="0" />
        </filter>
        <rect width="100%" height="100%" filter="url(#jsl-grain)" />
      </svg>
    </div>
  );
}
